import {
  Building2,
  CalendarDays,
  DoorOpen,
  Home,
  LogOut,
  Settings,
  UserRound,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { UserMenuItem } from "../../sidebar/components/user-menu-item";
import { useLogout } from "@/core/components/auth/hooks/useLogout";

/**
 * Mesmos destinos do UserMenu legado, com iconografia lucide (PED-12262).
 */
export function WosUserMenu({
  as = "dropdown",
}: {
  as?: "dropdown" | "sheet";
}) {
  const [translate] = useTranslation(["core"]);
  const { signOut } = useLogout();

  const iconClass = "size-4 text-primary";

  return (
    <>
      <UserMenuItem
        title={translate("user-menu-profile-link")}
        icon={() => <UserRound className={iconClass} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/me`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-bookings-link")}
        icon={() => <CalendarDays className={iconClass} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/bookings`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-coworking-link")}
        icon={() => <Building2 className={iconClass} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/my-coworking`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-meetingrooms-link")}
        icon={() => <DoorOpen className={iconClass} />}
        url={`${import.meta.env.VITE_LISTING_URL}?product=mr`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-home-link")}
        icon={() => <Home className={iconClass} />}
        url={`${import.meta.env.VITE_PORTAL_URL}`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-settings-link")}
        icon={() => <Settings className={iconClass} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/configuration`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-logout")}
        icon={() => <LogOut className={iconClass} />}
        onClick={signOut}
        as={as}
      />
    </>
  );
}
